import { actionTypes } from "../_actions/sdkClient.action";

const initialState = {
  instance: null,
};

const sdkClient = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_CLIENT:
      console.log("SAVE_CLIENT", {...action.data, currentInstance: state.instance })
      return {
        ...state,
        instance: action.data,
      };
    default:
      return state;
  }
};

export default sdkClient;
